import React, { useState, useEffect } from 'react';
import {
    HiFilter,
    HiChevronUp,
    HiChevronDown,
    HiAdjustments,
    HiClipboardCheck,
    HiBriefcase,
    HiBeaker,
    HiOutlineLightBulb,
    HiInformationCircle,
    HiCalendar,
    HiFingerPrint
} from 'react-icons/hi';
import apiService from '../services/apiService';
import { useAuth } from '../context/AuthContext';

const FiltersPanel = ({ onFiltersChange, onApplyFilters, isDisabled = false, importedFilters, saveStatus }) => {
    const { user } = useAuth();
    const [filters, setFilters] = useState({
        trlInitial: 1,
        trlFinal: 9,
        crlInitial: 1,
        crlFinal: 9,
        innovationDegree: {
            1: false,
            2: false,
            3: false
        },
        typology: [],
        status: [],
        portfolio: [],
        technologicalInitiative: [],
        category: [],
        dataMin: '',
        dataMax: '',
        previsoes: false
    });

    const [availableFilters, setAvailableFilters] = useState(null);

    useEffect(() => {
        if (!importedFilters) return;
        setFilters({
            trlInitial: 1, trlFinal: 9, crlInitial: 1, crlFinal: 9,
            innovationDegree: { 1: false, 2: false, 3: false },
            typology: [], status: [], portfolio: [], technologicalInitiative: [], category: [],
            dataMin: '', dataMax: '', previsoes: false,
            ...importedFilters,
        });
    }, [importedFilters]);
    const [expandedSections, setExpandedSections] = useState({
        parameters: true,
        innovationDegree: true,
        category: false,
        data: false,
        typology: false,
        status: false,
        portfolio: false,
        technologicalInitiative: false
    });

    const [innovationDegreeName, setInovationDegreeeName] = useState({
        "1": "Incremental",
        "2": "Breaktrough",
        "3": "Disruptiva"
    })

    const [categoryName, setCategoryName] = useState({
        "EX": "Experimento",
        "EP": "Entrega Potencial",
        "EV": "Entrega de Valor",
        "ES": "Entrega de Valor Simplificada",
        "EG": "Entrega de Grande Porte",
        "IE": "Infraestrutura Externa"
    })

    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        loadAvailableFilters();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [user]);

    const loadAvailableFilters = async () => {
        try {
            setLoading(true);

            // Verificar se o usuário tem permissão para carregar filtros
            if (user?.acesso === 'Não verificado') {
                setError('Você não tem permissão para acessar os filtros.');
                setLoading(false);
                return;
            }

            const data = await apiService.getFilters();
            // ############## APENAS POR HORA #################
            const removeStatus = [
                // "Cancelada",
                // "Concluida",
                "Descartada",
                "Elb-Aprovacao",
                "Em Elaboracao",
                // "Em Execucao",
                "Exe-Aprovacao"
            ];
            const newData = {
                ...data,
                status: data.status.filter(s => !removeStatus.includes(s))
            };

            setAvailableFilters(newData);
            setError(null);
        } catch (err) {
            setError('Falha ao carregar opções de filtro');
            console.error('Erro ao carregar filtros:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleFilterChange = (field, value) => {
        const newFilters = {
            ...filters,
            [field]: value
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const handleInnovationDegreeChange = (level) => {
        const newInnovationDegree = {
            ...filters.innovationDegree,
            [level]: !filters.innovationDegree[level]
        };
        const newFilters = {
            ...filters,
            innovationDegree: newInnovationDegree
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const handleMultiSelectChange = (field, value) => {
        const currentValues = filters[field] || [];
        const newValues = currentValues.includes(value)
            ? currentValues.filter(v => v !== value)
            : [...currentValues, value];

        handleFilterChange(field, newValues);
    };

    const handleDateMinChange = (dateValue) => {
        if (!dateValue) {
            handleFilterChange('dataMin', '');
            return;
        }

        // Converter a data para o formato desejado: "%Y-%m-%d_%H-%M-%S"
        const date = new Date(dateValue);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        handleFilterChange('dataMin', formattedDate);
    };

    const handleDateMaxChange = (dateValue) => {
        if (!dateValue) {
            handleFilterChange('dataMax', '');
            return;
        }

        // Converter a data para o formato desejado: "%Y-%m-%d_%H-%M-%S"
        const date = new Date(dateValue);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        const formattedDate = `${year}-${month}-${day}_${hours}-${minutes}-${seconds}`;
        handleFilterChange('dataMax', formattedDate);
    };

    const toggleSection = (section) => {
        setExpandedSections(prev => ({
            ...prev,
            [section]: !prev[section]
        }));
    };

    const handleApplyFilters = () => {
        onApplyFilters(filters);
    };

    const handleClearFilters = () => {
        const defaultFilters = {
            trlInitial: 1,
            trlFinal: 9,
            crlInitial: 1,
            crlFinal: 9,
            innovationDegree: {
                1: false,
                2: false,
                3: false
            },
            typology: [],
            status: [],
            portfolio: [],
            technologicalInitiative: [],
            category: [],
            dataMin: '',
            dataMax: '',
            previsoes: false
        };
        setFilters(defaultFilters);
        onFiltersChange(defaultFilters);
    };

    // Funções para verificar se cada filtro foi alterado
    const isParametersChanged = () => {
        return filters.trlInitial !== 1 || filters.trlFinal !== 9 ||
               filters.crlInitial !== 1 || filters.crlFinal !== 9;
    };

    const isInnovationDegreeChanged = () => {
        return Object.values(filters.innovationDegree).some(val => val === true);
    };

    const isCategoryChanged = () => {
        return filters.category.length > 0;
    };

    const isTypologyChanged = () => {
        return filters.typology.length > 0;
    };

    const isStatusChanged = () => {
        return filters.status.length > 0;
    };

    const isPortfolioChanged = () => {
        return filters.portfolio.length > 0;
    };

    const isTechnologicalInitiativeChanged = () => {
        return filters.technologicalInitiative.length > 0;
    };

    const isDataChanged = () => {
        return filters.dataMin !== '' || filters.dataMax !== '' || filters.previsoes !== false;
    };

    // Funções para limpar cada categoria individualmente
    const clearParameters = () => {
        const newFilters = {
            ...filters,
            trlInitial: 1,
            trlFinal: 9,
            crlInitial: 1,
            crlFinal: 9
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const clearInnovationDegree = () => {
        const newFilters = {
            ...filters,
            innovationDegree: { 1: false, 2: false, 3: false }
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const clearCategory = () => {
        const newFilters = {
            ...filters,
            category: []
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const clearTypology = () => {
        const newFilters = {
            ...filters,
            typology: []
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const clearStatus = () => {
        const newFilters = {
            ...filters,
            status: []
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const clearPortfolio = () => {
        const newFilters = {
            ...filters,
            portfolio: []
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const clearTechnologicalInitiative = () => {
        const newFilters = {
            ...filters,
            technologicalInitiative: []
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    const clearData = () => {
        const newFilters = {
            ...filters,
            dataMin: '',
            dataMax: '',
            previsoes: false
        };
        setFilters(newFilters);
        onFiltersChange(newFilters);
    };

    if (loading) {
        return (
            <div className="w-1/4 bg-white shadow-lg border-r border-gray-200 h-full flex flex-col">
                <div className="bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 h-20 flex items-center justify-between flex-shrink-0">
                    <span className="text-lg font-semibold">Filtros</span>
                    <HiFilter className="w-5 h-5" />
                </div>
                <div className="flex-1 flex items-center justify-center bg-gray-50">
                    <div className="text-center">
                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto mb-4"></div>
                        <p className="text-sm text-gray-500">Carregando filtros...</p>
                    </div>
                </div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="w-1/4 bg-white shadow-lg border-r border-gray-200 h-full flex flex-col">
                <div className="bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 h-20 flex items-center justify-between flex-shrink-0">
                    <span className="text-lg font-semibold">Filtros</span>
                    <HiFilter className="w-5 h-5" />
                </div>
                <div className="flex-1 flex items-center justify-center">
                    <div className="p-6 text-center text-red-600">{error}</div>
                </div>
            </div>
        );
    }

    return (
        <div className="w-1/4 bg-white shadow-lg border-r border-gray-200 h-full flex flex-col">
            <div className="bg-gradient-to-r from-slate-700 to-slate-600 text-white px-6 py-4 h-20 flex items-center justify-between flex-shrink-0">
                <span className="text-lg font-semibold">Filtros</span>
                <HiFilter className="w-5 h-5" />
            </div>

            {/* Fixed buttons at top */}
            <div className="bg-white px-6 py-4 border-gray-200 flex-shrink-0">
                <button
                    style={{ backgroundColor: "#003B6B" }}
                    className="w-full text-white font-semibold py-3 px-4 rounded-lg transition-all duration-200 shadow-md hover:shadow-lg hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed"
                    onClick={handleApplyFilters}
                    disabled={isDisabled}
                >
                    Aplicar filtros
                </button>
                {saveStatus && (
                    <p
                        role={saveStatus.tipo === 'erro' ? 'alert' : 'status'}
                        className={`mt-2 mb-0 text-sm text-center ${saveStatus.tipo === 'erro' ? 'text-red-600' : saveStatus.tipo === 'salvo' ? 'text-green-700' : 'text-gray-500'}`}
                    >
                        {saveStatus.mensagem}
                    </p>
                )}

                {/* <button
                    className="w-full mt-2 text-gray-600 font-medium py-2 px-4 border border-gray-300 rounded-lg transition-all duration-200 hover:bg-gray-50 hover:border-gray-400"
                    onClick={handleClearFilters}
                >
                    Limpar filtros
                </button> */}
            </div>

            <div className={`flex-1 overflow-y-auto custom-scrollbar ${isDisabled ? 'pointer-events-none opacity-50' : ''}`}>
                <div className="p-6">
                    <div className="space-y-6">
                        {/* Parameters Selection */}
                        <div className="border-b border-gray-200 pb-6">
                            <div className="w-full flex items-center justify-between">
                                <button
                                    className="flex items-center space-x-2 flex-1 text-left"
                                    onClick={() => toggleSection('parameters')}
                                >
                                    <HiInformationCircle className="w-4 h-4 text-gray-500" />
                                    <span className="text-sm font-semibold text-gray-700">Seleção de parâmetros</span>
                                </button>

                                <div className="flex items-center space-x-2">
                                    {isParametersChanged() && (
                                        <button
                                            onClick={clearParameters}
                                            className="btn btn-outline-dark"
                                            style={{ fontSize: '0.7rem', padding: '0.15rem 0.4rem' }}
                                            title="Limpar filtros de parâmetros"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                    <button onClick={() => toggleSection('parameters')}>
                                        {expandedSections.parameters ?
                                            <HiChevronUp className="w-4 h-4 text-gray-500" /> :
                                            <HiChevronDown className="w-4 h-4 text-gray-500" />
                                        }
                                    </button>
                                </div>
                            </div>

                            {expandedSections.parameters && (
                                <div className="mt-4 space-y-4">
                                    <div className="grid grid-cols-2 gap-2 text-xs text-gray-500 mb-2">
                                        <span className="text-center">Inicial</span>
                                        <span className="text-center">Final</span>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <span className="text-sm font-medium text-gray-700 w-8">TRL</span>
                                        <select
                                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            value={filters.trlInitial}
                                            onChange={(e) => handleFilterChange('trlInitial', parseInt(e.target.value))}
                                        >
                                            {availableFilters?.trlRange?.map(num => (
                                                <option key={num} value={num}>{num}</option>
                                            ))}
                                        </select>
                                        <select
                                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            value={filters.trlFinal}
                                            onChange={(e) => handleFilterChange('trlFinal', parseInt(e.target.value))}
                                        >
                                            {availableFilters?.trlRange?.map(num => (
                                                <option key={num} value={num}>{num}</option>
                                            ))}
                                        </select>
                                    </div>

                                    <div className="flex items-center gap-2">
                                        <span className="text-sm font-medium text-gray-700 w-8">CRL</span>
                                        <select
                                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            value={filters.crlInitial}
                                            onChange={(e) => handleFilterChange('crlInitial', parseInt(e.target.value))}
                                        >
                                            {availableFilters?.crlRange?.map(num => (
                                                <option key={num} value={num}>{num}</option>
                                            ))}
                                        </select>
                                        <select
                                            className="flex-1 px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            value={filters.crlFinal}
                                            onChange={(e) => handleFilterChange('crlFinal', parseInt(e.target.value))}
                                        >
                                            {availableFilters?.crlRange?.map(num => (
                                                <option key={num} value={num}>{num}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Innovation Degree */}
                        <div className="border-b border-gray-200 pb-4">
                            <div className="w-full flex items-center justify-between">
                                <button
                                    className="flex items-center space-x-2 flex-1 text-left"
                                    onClick={() => toggleSection('innovationDegree')}
                                >
                                    <HiOutlineLightBulb className="w-4 h-4 text-gray-500" />
                                    <span className="text-sm font-semibold text-gray-700">Grau de inovação</span>
                                </button>

                                <div className="flex items-center space-x-2">
                                    {isInnovationDegreeChanged() && (
                                        <button
                                            onClick={clearInnovationDegree}
                                            className="btn btn-outline-dark"
                                            style={{ fontSize: '0.7rem', padding: '0.15rem 0.4rem' }}
                                            title="Limpar filtros de grau de inovação"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                    <button onClick={() => toggleSection('innovationDegree')}>
                                        {expandedSections.innovationDegree ?
                                            <HiChevronUp className="w-4 h-4 text-gray-500" /> :
                                            <HiChevronDown className="w-4 h-4 text-gray-500" />
                                        }
                                    </button>
                                </div>
                            </div>

                            {expandedSections.innovationDegree && (
                                <div className="mt-4 space-y-3">
                                    {availableFilters?.grauInovacao?.map(level => (
                                        <label key={level} className="flex items-center space-x-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={filters.innovationDegree[level] || false}
                                                onChange={() => handleInnovationDegreeChange(level)}
                                                className="h-4 w-4 text-blue-600 focus:ring-0 focus:ring-offset-0 border-gray-300 rounded focus:outline-none"
                                            />
                                            <span className="text-sm text-gray-700">{level} - {innovationDegreeName[level]}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Category */}
                        <div className="border-b border-gray-200 pb-4">
                            <div className="w-full flex items-center justify-between py-2">
                                <button
                                    className="flex items-center space-x-2 flex-1 text-left"
                                    onClick={() => toggleSection('category')}
                                >
                                    <HiFingerPrint className="w-4 h-4 text-gray-500" />
                                    <span className="text-sm font-medium text-gray-700">Categoria</span>
                                </button>

                                <div className="flex items-center space-x-2">
                                    {isCategoryChanged() && (
                                        <button
                                            onClick={clearCategory}
                                            className="btn btn-outline-dark"
                                            style={{ fontSize: '0.7rem', padding: '0.15rem 0.4rem' }}
                                            title="Limpar filtros de categoria"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                    <button onClick={() => toggleSection('category')}>
                                        {expandedSections.category ?
                                            <HiChevronUp className="w-4 h-4 text-gray-500" /> :
                                            <HiChevronDown className="w-4 h-4 text-gray-500" />
                                        }
                                    </button>
                                </div>
                            </div>

                            {expandedSections.category && (
                                <div className="mt-4 space-y-2">
                                    {availableFilters?.categoria?.map(cat => (
                                        <label key={cat} className="flex items-center space-x-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={filters.category.includes(cat)}
                                                onChange={() => handleMultiSelectChange('category', cat)}
                                                className="h-4 w-4 text-blue-600 focus:ring-0 focus:ring-offset-0 border-gray-300 rounded focus:outline-none"
                                            />
                                            <span className="text-sm text-gray-700">{cat} - {categoryName[cat] || cat}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Typology */}
                        <div className="border-b border-gray-200 pb-4">
                            <div className="w-full flex items-center justify-between py-2">
                                <button
                                    className="flex items-center space-x-2 flex-1 text-left"
                                    onClick={() => toggleSection('typology')}
                                >
                                    <HiAdjustments className="w-4 h-4 text-gray-500" />
                                    <span className="text-sm font-medium text-gray-700">Tipologia</span>
                                </button>

                                <div className="flex items-center space-x-2">
                                    {isTypologyChanged() && (
                                        <button
                                            onClick={clearTypology}
                                            className="btn btn-outline-dark"
                                            style={{ fontSize: '0.7rem', padding: '0.15rem 0.4rem' }}
                                            title="Limpar filtros de tipologia"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                    <button onClick={() => toggleSection('typology')}>
                                        {expandedSections.typology ?
                                            <HiChevronUp className="w-4 h-4 text-gray-500" /> :
                                            <HiChevronDown className="w-4 h-4 text-gray-500" />
                                        }
                                    </button>
                                </div>
                            </div>

                            {expandedSections.typology && (
                                <div className="mt-4 space-y-2">
                                    {availableFilters?.tipologia?.map(type => (
                                        <label key={type} className="flex items-center space-x-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={filters.typology.includes(type)}
                                                onChange={() => handleMultiSelectChange('typology', type)}
                                                className="h-4 w-4 text-blue-600 focus:ring-0 focus:ring-offset-0 border-gray-300 rounded focus:outline-none"
                                            />
                                            <span className="text-sm text-gray-700">{type}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Status */}
                        <div className="border-b border-gray-200 pb-4">
                            <div className="w-full flex items-center justify-between py-2">
                                <button
                                    className="flex items-center space-x-2 flex-1 text-left"
                                    onClick={() => toggleSection('status')}
                                >
                                    <HiClipboardCheck className="w-4 h-4 text-gray-500" />
                                    <span className="text-sm font-medium text-gray-700">Status</span>
                                </button>

                                <div className="flex items-center space-x-2">
                                    {isStatusChanged() && (
                                        <button
                                            onClick={clearStatus}
                                            className="btn btn-outline-dark"
                                            style={{ fontSize: '0.7rem', padding: '0.15rem 0.4rem' }}
                                            title="Limpar filtros de status"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                    <button onClick={() => toggleSection('status')}>
                                        {expandedSections.status ?
                                            <HiChevronUp className="w-4 h-4 text-gray-500" /> :
                                            <HiChevronDown className="w-4 h-4 text-gray-500" />
                                        }
                                    </button>
                                </div>
                            </div>

                            {expandedSections.status && (
                                <div className="mt-4 space-y-2">
                                    {availableFilters?.status?.map(status => (
                                        <label key={status} className="flex items-center space-x-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={filters.status.includes(status)}
                                                onChange={() => handleMultiSelectChange('status', status)}
                                                className="h-4 w-4 text-blue-600 focus:ring-0 focus:ring-offset-0 border-gray-300 rounded focus:outline-none"
                                            />
                                            <span className="text-sm text-gray-700">{status}</span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Portfolio */}
                        <div className="border-b border-gray-200 pb-4">
                            <div className="w-full flex items-center justify-between py-2">
                                <button
                                    className="flex items-center space-x-2 flex-1 text-left"
                                    onClick={() => toggleSection('portfolio')}
                                >
                                    <HiBriefcase className="w-4 h-4 text-gray-500" />
                                    <span className="text-sm font-medium text-gray-700">Portfólio</span>
                                </button>

                                <div className="flex items-center space-x-2">
                                    {isPortfolioChanged() && (
                                        <button
                                            onClick={clearPortfolio}
                                            className="btn btn-outline-dark"
                                            style={{ fontSize: '0.7rem', padding: '0.15rem 0.4rem' }}
                                            title="Limpar filtros de portfólio"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                    <button onClick={() => toggleSection('portfolio')}>
                                        {expandedSections.portfolio ?
                                            <HiChevronUp className="w-4 h-4 text-gray-500" /> :
                                            <HiChevronDown className="w-4 h-4 text-gray-500" />
                                        }
                                    </button>
                                </div>
                            </div>

                            {expandedSections.portfolio && (
                                <div className="mt-4 space-y-2 max-h-48 overflow-y-auto">
                                    {availableFilters?.portfolio?.map(portfolioId => (
                                        <label key={portfolioId} className="flex items-center space-x-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={filters.portfolio.includes(portfolioId)}
                                                onChange={() => handleMultiSelectChange('portfolio', portfolioId)}
                                                className="h-4 w-4 text-blue-600 focus:ring-0 focus:ring-offset-0 border-gray-300 rounded focus:outline-none"
                                            />
                                            <span className="text-sm text-gray-700">
                                                {portfolioId} - {availableFilters?.portfolioTitulos?.[portfolioId] || ''}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Technological Initiative */}
                        <div className="border-b border-gray-200 pb-4">
                            <div className="w-full flex items-center justify-between py-2">
                                <button
                                    className="flex items-center space-x-2 flex-1 text-left"
                                    onClick={() => toggleSection('technologicalInitiative')}
                                >
                                    <HiBeaker className="w-4 h-4 text-gray-500" />
                                    <span className="text-sm font-medium text-gray-700">Iniciativa tecnológica</span>
                                </button>

                                <div className="flex items-center space-x-2">
                                    {isTechnologicalInitiativeChanged() && (
                                        <button
                                            onClick={clearTechnologicalInitiative}
                                            className="btn btn-outline-dark"
                                            style={{ fontSize: '0.7rem', padding: '0.15rem 0.4rem' }}
                                            title="Limpar filtros de iniciativa tecnológica"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                    <button onClick={() => toggleSection('technologicalInitiative')}>
                                        {expandedSections.technologicalInitiative ?
                                            <HiChevronUp className="w-4 h-4 text-gray-500" /> :
                                            <HiChevronDown className="w-4 h-4 text-gray-500" />
                                        }
                                    </button>
                                </div>
                            </div>

                            {expandedSections.technologicalInitiative && (
                                <div className="mt-4 space-y-2 max-h-48 overflow-y-auto">
                                    {availableFilters?.iniciativaTecnologica?.map(initiative => (
                                        <label key={initiative} className="flex items-center space-x-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={filters.technologicalInitiative.includes(initiative)}
                                                onChange={() => handleMultiSelectChange('technologicalInitiative', initiative)}
                                                className="h-4 w-4 text-blue-600 focus:ring-0 focus:ring-offset-0 border-gray-300 rounded focus:outline-none"
                                            />
                                            <span className="text-sm text-gray-700">
                                                {initiative} - {availableFilters?.iniciativaTecnologicaTitulos?.[initiative] || ''}
                                            </span>
                                        </label>
                                    ))}
                                </div>
                            )}
                        </div>

                        {/* Data Filter */}
                        <div className="pb-4">
                            <div className="w-full flex items-center justify-between">
                                <button
                                    className="flex items-center space-x-2 flex-1 text-left"
                                    onClick={() => toggleSection('data')}
                                >
                                    <HiCalendar className="w-4 h-4 text-gray-500" />
                                    <span className="text-sm font-semibold text-gray-700">Data</span>
                                </button>

                                <div className="flex items-center space-x-2">
                                    {isDataChanged() && (
                                        <button
                                            onClick={clearData}
                                            className="btn btn-outline-dark"
                                            style={{ fontSize: '0.7rem', padding: '0.15rem 0.4rem' }}
                                            title="Limpar filtros de data"
                                        >
                                            Limpar
                                        </button>
                                    )}
                                    <button onClick={() => toggleSection('data')}>
                                        {expandedSections.data ?
                                            <HiChevronUp className="w-4 h-4 text-gray-500" /> :
                                            <HiChevronDown className="w-4 h-4 text-gray-500" />
                                        }
                                    </button>
                                </div>
                            </div>

                            {expandedSections.data && (
                                <div className="mt-4 space-y-4">
                                    <div>
                                        <label className="block text-xs font-medium text-gray-700 mb-1">
                                            Data mínima
                                        </label>
                                        <input
                                            type="datetime-local"
                                            min="1970-01-01T00:00"
                                            max={new Date().toISOString().slice(0, 16)}
                                            onChange={(e) => handleDateMinChange(e.target.value)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            placeholder="Data mínima"
                                        />
                                    </div>
                                    <div>
                                        <label className="block text-xs font-medium text-gray-700 mb-1">
                                            Data máxima
                                        </label>
                                        <input
                                            type="datetime-local"
                                            min="1970-01-01T00:00"
                                            max={new Date().toISOString().slice(0, 16)}
                                            onChange={(e) => handleDateMaxChange(e.target.value)}
                                            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                                            placeholder="Data máxima"
                                        />
                                    </div>
                                    <div className="pt-2">
                                        <label className="flex items-center space-x-3 cursor-pointer">
                                            <input
                                                type="checkbox"
                                                checked={filters.previsoes}
                                                onChange={(e) => handleFilterChange('previsoes', e.target.checked)}
                                                className="h-4 w-4 text-blue-600 focus:ring-0 focus:ring-offset-0 border-gray-300 rounded focus:outline-none"
                                            />
                                            <span className="text-sm text-gray-700">Incluir previsões na análise</span>
                                        </label>
                                        <p className="ml-7 text-xs text-gray-500 mt-1">
                                            Quando marcado, inclui dados de previsões na análise
                                        </p>
                                    </div>
                                    {/* {(filters.dataMin || filters.dataMax) && (
                                        <div className="mt-2 text-xs text-gray-500">
                                            {filters.dataMin && <div>Min: {filters.dataMin}</div>}
                                            {filters.dataMax && <div>Max: {filters.dataMax}</div>}
                                        </div>
                                    )} */}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FiltersPanel;

